/**
 * Feature flag utilities for conditional rendering and routing
 */
import type { Feature, FeatureFlags, SiteConfig } from '@/types'

// Site config is loaded from generated JSON at build time
// This will be populated by the static generation script
let siteConfig: SiteConfig | null = null

export async function loadSiteConfig(): Promise<SiteConfig> {
  if (siteConfig) return siteConfig
  
  try {
    const response = await fetch('/data/site-config.json')
    siteConfig = await response.json()
    return siteConfig!
  } catch (error) {
    console.error('Failed to load site config:', error)
    // Return minimal config for development
    return {
      tenant_id: 0,
      name: 'Development Site',
      slug: 'dev',
      features: {
        ecommerce: true,
        blog: true,
        appointments: false,
        reviews: true,
        wishlist: true,
        loyalty_program: false,
        live_chat: false,
        newsletter: true,
        search: true,
        multi_currency: false,
        multi_language: false,
        custom_forms: false,
        analytics_dashboard: false,
      },
      theme: {
        logo_url: '',
        favicon_url: '',
        primary_color: '#000000',
        secondary_color: '#ffffff',
        font_family: 'Inter',
        header_style: 'default',
        footer_style: 'default',
      },
      settings: {
        timezone: 'UTC',
        date_format: 'YYYY-MM-DD',
        currency: 'INR',
        currency_symbol: '₹',
        maintenance_mode: false,
        coming_soon_mode: false,
      },
    }
  }
}

export function getSiteConfig(): SiteConfig | null {
  return siteConfig
}

export function getFeatures(): FeatureFlags {
  return siteConfig?.features ?? {} as FeatureFlags
}

export function isFeatureEnabled(feature: Feature): boolean {
  return siteConfig?.features[feature] === true
}

export function getTheme() {
  return siteConfig?.theme ?? null
}

export function getSettings() {
  return siteConfig?.settings ?? null
}
